import { setUserCardOpened } from './actions';
import { trackOpenUserCard } from './tracking';
import { fetchUserProfileThunk } from '../userProfile';
import { currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';
import { isSpecialistSelector } from '../../selectors/isSpecialistSelector';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Открывает карточку собеседника на вкладке «О клиенте» по диплинку `?userCardTab=clientInfo`.
 * Карточка открывается независимо от результата загрузки профиля — если данных нет или
 * запрос упал, вкладка сама покажет пустое состояние или ошибку с повтором (см. TabError),
 * а не прячет карточку целиком.
 */
export const openClientInfoFromDeeplinkThunk = (): TThunkAction<Promise<void>> => async (dispatch, getState) => {
  const state = getState();
  const currentChat = currentOpenChatSelector(state);
  const isSpecialist = isSpecialistSelector(state);

  if (!currentChat || !isSpecialist) {
    return;
  }

  await dispatch(fetchUserProfileThunk(currentChat.chatId));

  const opponentId = currentChatOpponentIdSelector(state);

  dispatch(setUserCardOpened());
  trackOpenUserCard(currentChat, opponentId, opponentId);
};
